<template>
  <div id="app">
    <!-- 路由占位符 -->
    <router-view></router-view>
  </div>
</template>

<script>
const defaultSettings = require('./settings.js')
document.domain = defaultSettings.appUrl

export default {
  name: 'app'
}
</script>
